
   export class  AuthenticationEntity {
 /// define entity properties
} 
  